<template>
  <div class="global-footer">
    <div class="item">
      <!-- <span>关于我们</span>
      <span>联系我们</span>
      <span>工作机会</span>
      <span>网站地图</span>
      <span>广告合作</span>|
      <span>iPhone客户端</span>|
      <span>Android客户端</span>|
      <span>手机版</span>|
      <span>意见反馈</span> -->
      <a v-for="(item,i) in footerList"
         :href='item.href'
         :key="i"
         target='_blank'>{{item.value}}</a>
    </div>
    <div class="item">
      <span>经营许可证编号：京ICP证080575号 / 京ICP备09080840号 京公网安备110105007230</span>
    </div>
    <div class="item">
      <span>Copyright ©2009 www.360che.com All Rights Reserved. <a href="http://www.360che.com/"
           target='_blank'>卡车之家</a> 版权所有</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data () {
    return {
      footerList: [
        {
          value: '关于我们',
          href: 'http://www.360che.com/help/about/'
        },
        {
          value: '联系我们',
          href: 'http://www.360che.com/help/contact/'
        },
        {
          value: '工作机会',
          href: 'http://www.360che.com/help/job/'
        },
        {
          value: '网站地图',
          href: 'http://www.360che.com/help/sitemap/'
        },
        {
          value: '广告合作',
          href: 'http://www.360che.com/help/ad/'
        },
        {
          value: 'iPhone客户端',
          href: 'https://app.360che.com/'
        },
        {
          value: 'Android客户端',
          href: 'https://app.360che.com/'
        },
        {
          value: '意见反馈',
          href: 'http://www.360che.com/help/suggest/index.html'
        }
      ]
    }
  },
  methods: {
  }
}
</script>
<style lang='less' scoped>
.global-footer {
  height: 72px;
  width: 1300px;
  border-top: 3px solid #0f5489;
  text-align: center;
  margin: 20px auto;
  padding-top: 15px;
  .item span {
    font-size: 12px;
    margin: 0 5px;
    font-size: 12px;
    color: #5c6066;
    line-height: 24px;
  }
  .item a {
    font-size: 12px;
    margin: 0 5px;
    font-size: 12px;
    color: #5c6066;
    line-height: 24px;
    &:hover {
      color: #2d8cf0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalFooter.vue